export default "__VITE_ASSET__DBRIMzWQ__"